import { render, staticRenderFns } from "./ProjectCase.vue?vue&type=template&id=c542162e&scoped=true"
import script from "./ProjectCase.vue?vue&type=script&lang=js"
export * from "./ProjectCase.vue?vue&type=script&lang=js"
import style0 from "./ProjectCase.vue?vue&type=style&index=0&id=c542162e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c542162e",
  null
  
)

export default component.exports